// import { Component, OnInit } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { Router } from '@angular/router';
// import { ToastrService } from 'ngx-toastr';
// import { AccountService } from '../_services/domainservice/account.service';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { AuthService } from '../_services/auth.service';
// import { SharedComponent } from '../../shared/shared.component';

// @Component({
//   selector: 'app-register',
//   templateUrl: './register.component.html',
//   styleUrls: ['./register.component.css']
// })
// export class RegisterComponent extends SharedComponent implements OnInit {
//   forgetPasswordForm: FormGroup;
//   submitted = false;
//   otpSent: boolean = false;
//   errorMessage: string = '';

//   constructor(
//     private formBuilder: FormBuilder,
//     private router: Router,
//     private toastr: ToastrService,
//     private accountService: AccountService,
//     private spinner: NgxSpinnerService,
//     private authService: AuthService
//   ) { super(); }

//   ngOnInit() {
//     this.forgetPasswordForm = this.formBuilder.group({
//       email: ['', [Validators.required, Validators.email]]
//     });
//   }

//   get f() { return this.forgetPasswordForm.controls; }

//   onSubmit() {
//     this.submitted = true;

//     if (this.forgetPasswordForm.invalid) {
//       return;
//     }

//     this.spinner.show();
//     this.accountService.getAccountEmail(this.getBase64Encode(this.forgetPasswordForm.value.email)).subscribe((accountdata): void => {
//       this.spinner.hide();
//       this.otpSent = true;
//       this.toastr.success('OTP sent to your email');
//       this.router.navigate(['/sendotp'], { queryParams: { email: this.forgetPasswordForm.value.email } });
//     },
//       error => {
//         this.spinner.hide();
//         this.errorMessage = 'Error sending OTP. Please try again.';
//         this.toastr.error(this.errorMessage);
//       }
//     );
    //this.authService.sendOtp(this.forgetPasswordForm.value.email).subscribe(
    //  response => {
    //    this.spinner.hide();
    //    this.otpSent = true;
    //    this.toastr.success('OTP sent to your email');
    //    this.router.navigate(['/sendotp'], { queryParams: { email: this.forgetPasswordForm.value.email } });
    //  },
    //  error => {
    //    this.spinner.hide();
    //    this.errorMessage = 'Error sending OTP. Please try again.';
    //    this.toastr.error(this.errorMessage);
    //  }
    //);
//   }
// }




// import { Component, OnInit, OnDestroy, QueryList, ViewChildren, ElementRef } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { Router } from '@angular/router';
// import { AccountService } from '../_services/domainservice/account.service'; // adjust path to your AccountService

// /**
//  * REGISTER — self-registration wizard (NEW).
//  * Step 1: account details + choose OTP channel  ->  sends OTP
//  * Step 2: verify the 6-digit OTP
//  * Step 3: pick product(s)                        ->  creates the account
//  *
//  * Backend touch-points are marked with TODO. They map to the new
//  * SQL tables / endpoints (see auth-tables.sql):
//  *   - sendOtp(channel, target)        -> writes OtpVerification row, emails/SMS the code
//  *   - verifyOtp(target, code)         -> validates against OtpVerification
//  *   - register(account + products)    -> creates ABGTechnologysAccount(s)
//  */
// @Component({
//   selector: 'app-register',
//   templateUrl: './register.component.html',
//   styleUrls: ['./register.component.css']
// })
// export class RegisterComponent implements OnInit, OnDestroy {

//   @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef<HTMLInputElement>>;

//   step = 1;
//   loading = false;
//   errorMessage = '';
//   successMessage = '';
//   showPassword = false;

//   registerForm!: FormGroup;
//   accSubmitted = false;

//   otpChannel: 'email' | 'mobile' = 'email';

//   // OTP state
//   otpBoxes = [0, 1, 2, 3, 4, 5];
//   otpDigits: string[] = ['', '', '', '', '', ''];
//   resendCountdown = 0;
//   private resendTimer: any;

//   // password strength
//   passwordStrength = 0;
//   strengthClass = '';

//   // products
//   products = [
//     { id: 'GYM', name: 'GYM Management', icon: 'la-heartbeat', cssClass: 'auth-pi--gym' },
//     { id: 'CRM', name: 'CRM & Inventory', icon: 'la-cubes', cssClass: 'auth-pi--crm' },
//     { id: 'TICKET', name: 'Ticket Management', icon: 'la-ticket', cssClass: 'auth-pi--ticket' },
//     { id: 'BILLING', name: 'Billing Application', icon: 'la-file-text-o', cssClass: 'auth-pi--billing' },
//     { id: 'HRM', name: 'HRM Application', icon: 'la-users', cssClass: 'auth-pi--hrm' }
//   ];
//   selectedProducts: string[] = [];

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly router: Router,
//     private readonly accountService: AccountService
//   ) { }

//   ngOnInit(): void {
//     this.registerForm = this.fb.group({
//       fullName: ['', Validators.required],
//       email: ['', [Validators.required, Validators.email]],
//       mobile: ['', [Validators.required, Validators.minLength(10), Validators.pattern(/^[0-9]{10}$/)]],
//       password: ['', [Validators.required, Validators.minLength(8)]]
//     });
//   }

//   ngOnDestroy(): void {
//     if (this.resendTimer) { clearInterval(this.resendTimer); }
//   }

//   get rf() { return this.registerForm.controls; }

//   // ─── STEP 1 ────────────────────────────────────────────────
//   submitAccount(): void {
//     this.accSubmitted = true;
//     this.errorMessage = '';
//     if (this.registerForm.invalid) { return; }

//     this.loading = true;
//     const target = this.otpChannel === 'email'
//       ? this.registerForm.value.email
//       : this.registerForm.value.mobile;

//     // TODO backend: check email/mobile uniqueness then send OTP.
//     // You already have GetABGTechnologysAccountValidation(EmailId, MobileNumber).
//     // Wire a new sendOtp endpoint that inserts into OtpVerification + dispatches the code.
//     this.accountService.sendOtp(this.otpChannel, target).subscribe({
//       next: () => {
//         this.loading = false;
//         this.step = 2;
//         this.startResendCountdown();
//         setTimeout(() => this.focusOtp(0), 50);
//       },
//       error: (err: any) => {
//         this.loading = false;
//         this.errorMessage = err?.error || 'Could not send the code. Please try again.';
//       }
//     });
//   }

//   onPasswordChange(): void {
//     const v: string = this.registerForm.value.password || '';
//     let score = 0;
//     if (v.length >= 8) { score++; }
//     if (/[A-Z]/.test(v) && /[a-z]/.test(v)) { score++; }
//     if (/[0-9]/.test(v) && /[^A-Za-z0-9]/.test(v)) { score++; }
//     this.passwordStrength = score;
//     this.strengthClass = score <= 1 ? 'weak' : score === 2 ? 'medium' : 'strong';
//   }

//   // ─── STEP 2: OTP ───────────────────────────────────────────
//   onOtpInput(event: Event, index: number): void {
//     const input = event.target as HTMLInputElement;
//     const val = input.value.replace(/[^0-9]/g, '');
//     this.otpDigits[index] = val.slice(-1);
//     input.value = this.otpDigits[index];
//     if (this.otpDigits[index] && index < 5) { this.focusOtp(index + 1); }
//   }

//   onOtpKeydown(event: KeyboardEvent, index: number): void {
//     if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
//       this.focusOtp(index - 1);
//     }
//   }

//   onOtpPaste(event: ClipboardEvent): void {
//     event.preventDefault();
//     const text = (event.clipboardData?.getData('text') || '').replace(/[^0-9]/g, '').slice(0, 6);
//     for (let i = 0; i < 6; i++) { this.otpDigits[i] = text[i] || ''; }
//     this.focusOtp(Math.min(text.length, 5));
//   }

//   private focusOtp(i: number): void {
//     const arr = this.otpInputs?.toArray();
//     if (arr && arr[i]) { arr[i].nativeElement.focus(); }
//   }

//   isOtpComplete(): boolean {
//     return this.otpDigits.every(d => d && d.length === 1);
//   }

//   verifyOtp(): void {
//     if (!this.isOtpComplete()) { return; }
//     this.loading = true;
//     this.errorMessage = '';
//     const code = this.otpDigits.join('');
//     const target = this.otpChannel === 'email'
//       ? this.registerForm.value.email
//       : this.registerForm.value.mobile;

//     // TODO backend: verify against OtpVerification (match, not expired, not used)
//     this.accountService.verifyOtp(target, code).subscribe({
//       next: () => {
//         this.loading = false;
//         this.successMessage = '';
//         this.step = 3;
//       },
//       error: (err: any) => {
//         this.loading = false;
//         this.errorMessage = err?.error || 'Invalid or expired code.';
//       }
//     });
//   }

//   resendOtp(): void {
//     if (this.resendCountdown > 0) { return; }
//     const target = this.otpChannel === 'email'
//       ? this.registerForm.value.email
//       : this.registerForm.value.mobile;
//     this.accountService.sendOtp(this.otpChannel, target).subscribe({
//       next: () => { this.successMessage = 'A new code has been sent.'; this.startResendCountdown(); },
//       error: () => { this.errorMessage = 'Could not resend the code.'; }
//     });
//   }

//   private startResendCountdown(): void {
//     this.resendCountdown = 30;
//     if (this.resendTimer) { clearInterval(this.resendTimer); }
//     this.resendTimer = setInterval(() => {
//       this.resendCountdown--;
//       if (this.resendCountdown <= 0) { clearInterval(this.resendTimer); }
//     }, 1000);
//   }

//   // ─── STEP 3: PRODUCTS ──────────────────────────────────────
//   isProductSelected(id: string): boolean {
//     return this.selectedProducts.indexOf(id) !== -1;
//   }

//   toggleProduct(id: string): void {
//     const i = this.selectedProducts.indexOf(id);
//     if (i === -1) { this.selectedProducts.push(id); }
//     else { this.selectedProducts.splice(i, 1); }
//   }

//   finishRegistration(): void {
//     if (this.selectedProducts.length === 0) { return; }
//     this.loading = true;
//     this.errorMessage = '';

//     const payload = {
//       fullName: this.registerForm.value.fullName,
//       email: this.registerForm.value.email,
//       mobile: this.registerForm.value.mobile,
//       password: this.registerForm.value.password,
//       products: this.selectedProducts
//     };

//     // TODO backend: create the admin account + product access rows.
//     // You can reuse POST api/ABGTechnologysAccounts (one per product) or a
//     // dedicated register endpoint that fans out to the chosen products.
//     this.accountService.register(payload).subscribe({
//       next: () => {
//         this.loading = false;
//         this.successMessage = 'Account created! Redirecting to sign in…';
//         setTimeout(() => this.router.navigate(['/login']), 1400);
//       },
//       error: (err: any) => {
//         this.loading = false;
//         this.errorMessage = err?.error || 'Could not create the account. Please try again.';
//       }
//     });
//   }
// }




// import { Component, OnDestroy, OnInit, QueryList, ViewChildren, ElementRef } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { Router } from '@angular/router';
// import { AccountService } from '../_services/domainservice/account.service';

// @Component({
//   selector: 'app-register',
//   templateUrl: './register.component.html',
//   styleUrls: ['./register.component.css']
// })
// export class RegisterComponent implements OnInit, OnDestroy {
//   @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef<HTMLInputElement>>;

//   step = 1;
//   loading = false;
//   errorMessage = '';
//   successMessage = '';
//   showPassword = false;

//   registerForm!: FormGroup;
//   accSubmitted = false;

//   otpBoxes = [0, 1, 2, 3, 4, 5];
//   otpDigits: string[] = ['', '', '', '', '', ''];
//   resendCountdown = 0;
//   private resendTimer: any;

//   passwordStrength = 0;
//   strengthClass = '';

//   products = [
//     { id: 'GYM', name: 'GYM Management', icon: 'la-heartbeat', cssClass: 'auth-pi--gym' },
//     { id: 'CRM', name: 'CRM & Inventory', icon: 'la-cubes', cssClass: 'auth-pi--crm' },
//     { id: 'TICKET', name: 'Ticket Management', icon: 'la-ticket', cssClass: 'auth-pi--ticket' },
//     { id: 'BILLING', name: 'Billing Application', icon: 'la-file-text-o', cssClass: 'auth-pi--billing' },
//     { id: 'HRM', name: 'HRM Application', icon: 'la-users', cssClass: 'auth-pi--hrm' }
//   ];
//   selectedProducts: string[] = [];

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly router: Router,
//     private readonly accountService: AccountService
//   ) { }

//   ngOnInit(): void {
//     this.registerForm = this.fb.group({
//       fullName: ['', Validators.required],
//       email: ['', [Validators.required, Validators.email]],
//       mobile: ['', [Validators.required, Validators.minLength(10), Validators.pattern(/^[0-9]{10}$/)]],
//       password: ['', [Validators.required, Validators.minLength(8)]],
//       acceptTerms: [false, Validators.requiredTrue]
//     });
//   }

//   ngOnDestroy(): void {
//     if (this.resendTimer) {
//       clearInterval(this.resendTimer);
//     }
//   }

//   get rf() {
//     return this.registerForm.controls;
//   }

//   submitAccount(): void {
//     this.accSubmitted = true;
//     this.errorMessage = '';
//     this.successMessage = '';

//     if (this.registerForm.invalid) {
//       this.errorMessage = 'Please complete all required registration fields.';
//       return;
//     }

//     this.step = 3;
//   }

//   onPasswordChange(): void {
//     const v: string = this.registerForm.value.password || '';
//     let score = 0;
//     if (v.length >= 8) { score++; }
//     if (/[A-Z]/.test(v) && /[a-z]/.test(v)) { score++; }
//     if (/[0-9]/.test(v) && /[^A-Za-z0-9]/.test(v)) { score++; }
//     this.passwordStrength = score;
//     this.strengthClass = score <= 1 ? 'weak' : score === 2 ? 'medium' : 'strong';
//   }

//   onOtpInput(event: Event, index: number): void {
//     const input = event.target as HTMLInputElement;
//     const val = input.value.replace(/[^0-9]/g, '');
//     this.otpDigits[index] = val.slice(-1);
//     input.value = this.otpDigits[index];
//     if (this.otpDigits[index] && index < 5) {
//       this.focusOtp(index + 1);
//     }
//   }

//   onOtpKeydown(event: KeyboardEvent, index: number): void {
//     if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
//       this.focusOtp(index - 1);
//     }
//   }

//   onOtpPaste(event: ClipboardEvent): void {
//     event.preventDefault();
//     const text = (event.clipboardData?.getData('text') || '').replace(/[^0-9]/g, '').slice(0, 6);
//     for (let i = 0; i < 6; i++) {
//       this.otpDigits[i] = text[i] || '';
//     }
//     this.focusOtp(Math.min(text.length, 5));
//   }

//   private focusOtp(i: number): void {
//     const arr = this.otpInputs?.toArray();
//     if (arr && arr[i]) {
//       arr[i].nativeElement.focus();
//     }
//   }

//   isOtpComplete(): boolean {
//     return this.otpDigits.every(d => d && d.length === 1);
//   }

//   verifyOtp(): void {
//     if (!this.isOtpComplete()) {
//       return;
//     }

//     this.loading = true;
//     this.errorMessage = '';
//     this.successMessage = '';

//     const payload = {
//       email: this.registerForm.value.email,
//       emailCode: this.otpDigits.join('')
//     };

//     this.accountService.registerVerify(payload).subscribe({
//       next: () => {
//         this.loading = false;
//         this.successMessage = 'Account created. Redirecting to sign in...';
//         setTimeout(() => this.router.navigate(['/login']), 1400);
//       },
//       error: (err: any) => {
//         this.loading = false;
//         this.errorMessage = this.getErrorMessage(err, 'Invalid or expired code.');
//       }
//     });
//   }

//   resendOtp(): void {
//     if (this.resendCountdown > 0) {
//       return;
//     }

//     this.errorMessage = 'Please restart registration to request a fresh code.';
//   }

//   private startResendCountdown(): void {
//     this.resendCountdown = 30;
//     if (this.resendTimer) {
//       clearInterval(this.resendTimer);
//     }

//     this.resendTimer = setInterval(() => {
//       this.resendCountdown--;
//       if (this.resendCountdown <= 0) {
//         clearInterval(this.resendTimer);
//       }
//     }, 1000);
//   }

//   isProductSelected(id: string): boolean {
//     return this.selectedProducts.indexOf(id) !== -1;
//   }

//   toggleProduct(id: string): void {
//     this.selectedProducts = this.isProductSelected(id) ? [] : [id];
//   }

//   finishRegistration(): void {
//     if (this.selectedProducts.length === 0) {
//       this.errorMessage = 'Select a product.';
//       return;
//     }

//     this.loading = true;
//     this.errorMessage = '';
//     this.successMessage = '';

//     const payload = {
//       fullName: this.registerForm.value.fullName,
//       email: this.registerForm.value.email,
//       mobile: this.registerForm.value.mobile,
//       password: this.registerForm.value.password,
//       productCode: this.selectedProducts[0],
//       acceptTerms: this.registerForm.value.acceptTerms === true
//     };

//     this.accountService.register(payload).subscribe({
//       next: () => {
//         this.loading = false;
//         this.step = 2;
//         this.otpDigits = ['', '', '', '', '', ''];
//         this.successMessage = 'Verification code sent to your email.';
//         this.startResendCountdown();
//         setTimeout(() => this.focusOtp(0), 50);
//       },
//       error: (err: any) => {
//         this.loading = false;
//         this.errorMessage = this.getErrorMessage(err, 'Could not start registration. Please try again.');
//       }
//     });
//   }

//   private getErrorMessage(err: any, fallback: string): string {
//     if (Array.isArray(err?.error?.errors)) {
//       return err.error.errors.join(', ');
//     }
//     if (typeof err?.error === 'string') {
//       return err.error;
//     }
//     if (typeof err?.error?.message === 'string') {
//       return err.error.message;
//     }
//     return fallback;
//   }
// }



// import { Component, OnDestroy, OnInit, QueryList, ViewChildren, ElementRef } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { Router } from '@angular/router';
// import { AccountService } from '../_services/domainservice/account.service';

// @Component({
//   selector: 'app-register',
//   templateUrl: './register.component.html',
//   styleUrls: ['./register.component.css']
// })
// export class RegisterComponent implements OnInit, OnDestroy {
//   @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef<HTMLInputElement>>;

//   step = 1;
//   loading = false;
//   errorMessage = '';
//   successMessage = '';
//   showPassword = false;

//   registerForm!: FormGroup;
//   accSubmitted = false;

//   otpBoxes = [0, 1, 2, 3, 4, 5];
//   otpDigits: string[] = ['', '', '', '', '', ''];
//   resendCountdown = 0;
//   private resendTimer: any;

//   passwordStrength = 0;
//   strengthClass = '';

//   products = [
//     { id: 'GYM', name: 'GYM Management', icon: 'la-heartbeat', cssClass: 'auth-pi--gym' },
//     { id: 'CRM', name: 'CRM & Inventory', icon: 'la-cubes', cssClass: 'auth-pi--crm' },
//     { id: 'TICKET', name: 'Ticket Management', icon: 'la-ticket', cssClass: 'auth-pi--ticket' },
//     { id: 'BILLING', name: 'Billing Application', icon: 'la-file-text-o', cssClass: 'auth-pi--billing' },
//     { id: 'HRM', name: 'HRM Application', icon: 'la-users', cssClass: 'auth-pi--hrm' }
//   ];
//   selectedProducts: string[] = [];

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly router: Router,
//     private readonly accountService: AccountService
//   ) { }

//   ngOnInit(): void {
//     this.registerForm = this.fb.group({
//       fullName: ['', Validators.required],
//       email: ['', [Validators.required, Validators.email]],
//       mobile: ['', [Validators.required, Validators.minLength(10), Validators.pattern(/^[0-9]{10}$/)]],
//       password: ['', [Validators.required, Validators.minLength(8)]],
//       acceptTerms: [false, Validators.requiredTrue]
//     });
//   }

//   ngOnDestroy(): void {
//     if (this.resendTimer) {
//       clearInterval(this.resendTimer);
//     }
//   }

//   get rf() {
//     return this.registerForm.controls;
//   }

//   submitAccount(): void {
//     this.accSubmitted = true;
//     this.errorMessage = '';
//     this.successMessage = '';

//     if (this.registerForm.invalid) {
//       this.errorMessage = 'Please complete all required registration fields.';
//       return;
//     }

//     this.step = 2;
//   }

//   onPasswordChange(): void {
//     const v: string = this.registerForm.value.password || '';
//     let score = 0;
//     if (v.length >= 8) { score++; }
//     if (/[A-Z]/.test(v) && /[a-z]/.test(v)) { score++; }
//     if (/[0-9]/.test(v) && /[^A-Za-z0-9]/.test(v)) { score++; }
//     this.passwordStrength = score;
//     this.strengthClass = score <= 1 ? 'weak' : score === 2 ? 'medium' : 'strong';
//   }

//   onOtpInput(event: Event, index: number): void {
//     const input = event.target as HTMLInputElement;
//     const val = input.value.replace(/[^0-9]/g, '');
//     this.otpDigits[index] = val.slice(-1);
//     input.value = this.otpDigits[index];
//     if (this.otpDigits[index] && index < 5) {
//       this.focusOtp(index + 1);
//     }
//   }

//   onOtpKeydown(event: KeyboardEvent, index: number): void {
//     if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) {
//       this.focusOtp(index - 1);
//     }
//   }

//   onOtpPaste(event: ClipboardEvent): void {
//     event.preventDefault();
//     const text = (event.clipboardData?.getData('text') || '').replace(/[^0-9]/g, '').slice(0, 6);
//     for (let i = 0; i < 6; i++) {
//       this.otpDigits[i] = text[i] || '';
//     }
//     this.focusOtp(Math.min(text.length, 5));
//   }

//   private focusOtp(i: number): void {
//     const arr = this.otpInputs?.toArray();
//     if (arr && arr[i]) {
//       arr[i].nativeElement.focus();
//     }
//   }

//   isOtpComplete(): boolean {
//     return this.otpDigits.every(d => d && d.length === 1);
//   }

//   verifyOtp(): void {
//     if (!this.isOtpComplete()) {
//       return;
//     }

//     this.loading = true;
//     this.errorMessage = '';
//     this.successMessage = '';

//     const payload = {
//       email: this.registerForm.value.email,
//       emailCode: this.otpDigits.join('')
//     };

//     this.accountService.registerVerify(payload).subscribe({
//       next: () => {
//         this.loading = false;
//         this.successMessage = 'Account created. Redirecting to sign in...';
//         setTimeout(() => this.router.navigate(['/login']), 1400);
//       },
//       error: (err: any) => {
//         this.loading = false;
//         this.errorMessage = this.getErrorMessage(err, 'Invalid or expired code.');
//       }
//     });
//   }

//   resendOtp(): void {
//     if (this.resendCountdown > 0) {
//       return;
//     }

//     this.errorMessage = 'Please restart registration to request a fresh code.';
//   }

//   private startResendCountdown(): void {
//     this.resendCountdown = 30;
//     if (this.resendTimer) {
//       clearInterval(this.resendTimer);
//     }

//     this.resendTimer = setInterval(() => {
//       this.resendCountdown--;
//       if (this.resendCountdown <= 0) {
//         clearInterval(this.resendTimer);
//       }
//     }, 1000);
//   }

//   isProductSelected(id: string): boolean {
//     return this.selectedProducts.indexOf(id) !== -1;
//   }

//   toggleProduct(id: string): void {
//     this.selectedProducts = this.isProductSelected(id) ? [] : [id];
//   }

//   finishRegistration(): void {
//     if (this.selectedProducts.length === 0) {
//       this.errorMessage = 'Select a product.';
//       return;
//     }

//     this.loading = true;
//     this.errorMessage = '';
//     this.successMessage = '';

//     const payload = {
//       fullName: this.registerForm.value.fullName,
//       email: this.registerForm.value.email,
//       mobile: this.registerForm.value.mobile,
//       password: this.registerForm.value.password,
//       productCode: this.selectedProducts[0],
//       acceptTerms: this.registerForm.value.acceptTerms === true
//     };

//     this.accountService.register(payload).subscribe({
//       next: () => {
//         this.loading = false;
//         this.step = 3;
//         this.otpDigits = ['', '', '', '', '', ''];
//         this.successMessage = 'Verification code sent to your email.';
//         this.startResendCountdown();
//         setTimeout(() => this.focusOtp(0), 50);
//       },
//       error: (err: any) => {
//         this.loading = false;
//         this.errorMessage = this.getErrorMessage(err, 'Could not start registration. Please try again.');
//       }
//     });
//   }

//   private getErrorMessage(err: any, fallback: string): string {
//     if (Array.isArray(err?.error?.errors)) {
//       return err.error.errors.join(', ');
//     }
//     if (typeof err?.error === 'string') {
//       return err.error;
//     }
//     if (typeof err?.error?.message === 'string') {
//       return err.error.message;
//     }
//     return fallback;
//   }
// }


// import { HttpClient, HttpErrorResponse } from '@angular/common/http';
// import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
// import { NgForm } from '@angular/forms';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { ActivatedRoute } from '@angular/router';
// import { DatatableComponent } from '@swimlane/ngx-datatable';

// import { SharedComponent } from '../../shared/shared.component';
// import { AlertService } from '../_services/alert.service';
// import { Guid } from '../_helpers/guid';

// import { RowStatuses } from '../model/masterModel/RowStatuses.model';
// import { RoleBasedLoggedin } from '../model/masterModel/RoleBasedLogedin.model';
// import { AccessRoleUID } from '../model/masterModel/AccessRole.model';

// import { ClientRegistration } from '../model/client.model';
// import { Account } from '../model/account.model';
// import { Product } from '../model/product.model';
// import { Accessrole } from '../model/accessrole.model';
// import { EngineerRegistration } from '../model/engineerregistration.model';
// import { CustomerRegistration } from '../model/gym.model';
// import { TraineeRegistration } from '../model/gymtraineeregistration.model';
// import { AttendanceEmployeeRegistration } from '../model/attendanceemployeeregisration.model';
// import { GYMManagerRegistration } from '../model/gymmanagerRegistration.model';

// import { ClientService } from '../_services/domainservice/Client.service';
// import { AccountService } from '../_services/domainservice/account.service';
// import { ProductService } from '../_services/domainservice/product.service';
// import { AccessroleService } from '../_services/domainservice/accessrole.service';
// import { EngineerRegistrationService } from '../_services/domainservice/engineerregistration.service';
// import { GymService } from '../_services/domainservice/gym.service';
// import { TraineeRegistrationService } from '../_services/domainservice/gymtraineeregistration.service';
// import { AttendanceEmployeeRegistrationService } from '../_services/domainservice/attendanceemployeeregistration.service';
// import { GYMManagerRegistrationService } from '../_services/domainservice/gymmanagerregistration.service';

// /** Product UIds that drive the account "Logged In" behaviour. */
// const PRODUCT_UID = {
//   ENGINEERING: '5bc1bed6-73ed-43a9-8394-fb28d1d20800',
//   GYM: '00000020-0000-0000-0000-000000000000',
//   ATTENDANCE: 'f2425376-90f1-488c-a694-16c8294db7ae'
// } as const;

// /** Legacy RoleBasedLoggedIn UIds persisted on older account rows. */
// const LEGACY_ROLE_UID = {
//   TRAINER: '00100000-0000-0000-0000-000000000000',
//   TRAINEE: '00200000-0000-0000-0000-000000000000',
//   MANAGER: '00500000-0000-0000-0000-000000000000'
// } as const;

// type RegistrationTab = 'client' | 'account';
// type RegistrationEntity = 'client' | 'account';

// @Component({
//   selector: 'app-register',
//     templateUrl: './register.component.html',
//     styleUrls: ['./register.component.css']
// })
// export class RegisterComponent extends SharedComponent implements OnInit {

//   // ─────────────────────────────── Shared state ───────────────────────────────
//   public breadcrumb: any;
//   action: string = 'Add';
//   /** Which grid is visible. */
//   activeTab: RegistrationTab = 'client';
//   /** Which entity the currently open modal belongs to (drives shared confirmations). */
//   currentEntity: RegistrationEntity = 'client';

//   // Access flags (parsed once instead of five separate localStorage reads)
//   deleteAccess = false;
//   fullcontrolAccess = false;
//   writeAccess = false;
//   readAccess = false;
//   harddeleteAccess = false;
//   addAccess = true;

//   currentDate = new Date();

//   // ─────────────────────────────── Client state ───────────────────────────────
//   client: ClientRegistration = new ClientRegistration();
//   ClientData!: ClientRegistration[];
//   private clientTempAll: ClientRegistration[] = [];
//   ClientRegistrationID: any;
//   ProductUID: Guid;
//   ProductDetailsList: Array<Product>;

//   onlineSearch = false;
//   referralFromFriendOrFamilyMember = false;
//   socialMedia = false;
//   advertisement = false;
//   other = false;

//   CommunicationAddr: string;
//   PermanentAddr: string;

//   logoChoosefile = 'Choose file';
//   signatureChoosefile = 'Choose file';
//   private logoFileToUpload: File = null;
//   private signatureFileToUpload: File = null;

//   // ─────────────────────────────── Account state ──────────────────────────────
//   account: Account = new Account();
//   AccountData!: Account[];
//   private accountTempAll: Account[] = [];
//   AccountRegistrationId: any;

//   ClientRegistrationUID: Guid;
//   AccessUID: Guid;
//   productUId: Guid;
//   loggedInUId: Guid;
//   clientRegistrationUId: string;

//   Clientregistrationlist: ClientRegistration[];
//   AccessRolelist: Accessrole[];
//   Engineerlist: EngineerRegistration[];
//   Customerlist: CustomerRegistration[];
//   Customerlists: Array<CustomerRegistration>;
//   Traineelist: TraineeRegistration[];
//   EmployeeList: AttendanceEmployeeRegistration[];
//   Managerlist: GYMManagerRegistration[];

//   Engineers: Array<EngineerRegistration> = [];
//   Customers: Array<CustomerRegistration> = [];
//   Trainees: Array<TraineeRegistration>;
//   Employees: Array<AttendanceEmployeeRegistration> = [];
//   Managers: Array<GYMManagerRegistration>;

//   LoggedInList: any = [];
//   GYMRadio = false;
//   DisplayLoggedIn = false;

//   // ─────────────────────────────── View children ──────────────────────────────
//   @ViewChild('clientTable', { static: false }) clientTable: DatatableComponent;
//   @ViewChild('accountTable', { static: false }) accountTable: DatatableComponent;
//   @ViewChild('ClientContent', { read: TemplateRef }) ClientContent: TemplateRef<any>;
//   @ViewChild('AccountContent', { read: TemplateRef }) AccountContent: TemplateRef<any>;
//   @ViewChild('clientForm', { static: false }) clientForm!: NgForm;
//   @ViewChild('accountForm', { static: false }) accountForm!: NgForm;
//   @ViewChild('labelImport', { static: true }) labelImport: ElementRef;

//   constructor(
//     private modalService: NgbModal,
//     private spinner: NgxSpinnerService,
//     readonly alertService: AlertService,
//     readonly clientService: ClientService,
//     readonly accountService: AccountService,
//     private productService: ProductService,
//     private accessRoleService: AccessroleService,
//     private engineerRegistrationService: EngineerRegistrationService,
//     private gymService: GymService,
//     private traineeService: TraineeRegistrationService,
//     private attendanceEmployeeRegistrationService: AttendanceEmployeeRegistrationService,
//     private gymmanagerService: GYMManagerRegistrationService,
//     private activaterouter: ActivatedRoute,
//     private http: HttpClient
//   ) {
//     super();
//   }

//   // ─────────────────────────────── Lifecycle ──────────────────────────────────
//   ngOnInit() {
//     const accessRole = JSON.parse(localStorage.getItem('currentUser')).accessRole;
//     this.deleteAccess = accessRole.delete;
//     this.fullcontrolAccess = accessRole.fullControl;
//     this.writeAccess = accessRole.write;
//     this.readAccess = accessRole.read;
//     this.harddeleteAccess = accessRole.hardDelete;

//     this.breadcrumb = {
//       mainlabel: 'Registration',
//       links: [
//         { name: 'Home', isLink: true, link: '/dashboard/sales' },
//         { name: 'Manage Registrations', isLink: true, link: '#' },
//         { name: 'Clients & Accounts', isLink: false },
//         { name: 'Select', isLink: false }
//       ]
//     };

//     // Deep-link support: /registration?clientRegistrationUId=... opens the
//     // account form prefilled from that client (previous cross-module workflow).
//     const uid = this.activaterouter.snapshot.queryParamMap.get('clientRegistrationUId');
//     if (uid) {
//       this.TransfertoAccountRegistration(uid);
//     }

//     this.getmasterdata();
//   }

//   getToday(): string {
//     return new Date().toISOString().split('T')[0];
//   }

//   setTab(tab: RegistrationTab) {
//     this.activeTab = tab;
//   }

//   // ─────────────────────────────── Master data ────────────────────────────────
//   getmasterdata() {
//     this.productService.getProduct().subscribe((getproductData): void => {
//       this.ProductDetailsList = getproductData;
//     });
//     this.clientService.getClient().subscribe((getClientRegistrationData: Array<ClientRegistration>): void => {
//       this.Clientregistrationlist = getClientRegistrationData;
//     });
//     this.accessRoleService.getAccessrole().subscribe((getAccessRoleData: Array<Accessrole>): void => {
//       this.AccessRolelist = getAccessRoleData;
//     });
//     this.engineerRegistrationService.getEngineerRegistration().subscribe((getEngineerData: Array<EngineerRegistration>): void => {
//       this.Engineerlist = getEngineerData;
//     });
//     this.traineeService.getTraineeRegistrationFilterUrl().subscribe((getTraineeData: Array<TraineeRegistration>): void => {
//       this.Traineelist = getTraineeData;
//     });
//     this.gymService.getGym(false, false, false, false, '0', '10').subscribe((getCustomerData: Array<CustomerRegistration>): void => {
//       this.Customerlist = getCustomerData['gymRegistrations'];
//       this.Customerlists = this.Customerlist;
//     });
//     this.attendanceEmployeeRegistrationService.getAttendanceEmployeeRegistration().subscribe((getemployeedata: Array<AttendanceEmployeeRegistration>): void => {
//       this.EmployeeList = getemployeedata;
//     });

//     this.spinner.show();
//     this.clientService.getClient().subscribe(
//       (data): void => {
//         this.spinner.hide();
//         this.ClientData = data;
//         this.clientTempAll = this.ClientData;
//       },
//       (error: HttpErrorResponse): void => {
//         console.log(error);
//         this.alertService.error(error.message);
//         this.spinner.hide();
//       }
//     );

//     this.spinner.show();
//     this.accountService.getAccount().subscribe(
//       (data): void => {
//         this.spinner.hide();
//         this.AccountData = data;
//         this.accountTempAll = this.AccountData;
//       },
//       (error: HttpErrorResponse): void => {
//         console.log(error);
//         this.alertService.error(error.message);
//         this.spinner.hide();
//       }
//     );
//   }

//   // ─────────────────────────────── Shared modal helpers ───────────────────────
//   private openModal(content: TemplateRef<any> | any) {
//     this.modalService.open(content, { windowClass: 'animated fadeInDown reg-modal', backdrop: 'static' });
//     setTimeout(() => {
//       const backdrop = document.getElementsByClassName('modal-backdrop')[0];
//       if (backdrop) { backdrop.removeAttribute('style'); }
//     }, 400);
//   }

//   /** Shared "unsaved changes" guard used by both modals. */
//   closePopup(form: NgForm, ChangesConfirmation: TemplateRef<any>) {
//     this.modalService.dismissAll();
//     if (form.dirty) {
//       this.openModal(ChangesConfirmation);
//     } else {
//       this.getmasterdata();
//     }
//   }

//   /** "No" on the unsaved-changes dialog re-opens the modal that was being edited. */
//   reopenCurrent() {
//     if (this.currentEntity === 'client') {
//       this.ViewClientPopup(this.ClientContent, this.action, this.client);
//     } else {
//       this.ViewAccountPopup(this.AccountContent, this.action, this.account);
//     }
//   }

//   /** "Yes" on the shared delete confirmation dispatches to the right save flow. */
//   confirmDelete() {
//     if (this.currentEntity === 'client') {
//       this.SaveClient(this.clientForm);
//     } else {
//       this.Saveaccount(this.accountForm);
//     }
//   }

//   // ════════════════════════════════ CLIENT ════════════════════════════════════

//   ViewClientPopup(Content, action, rowdata?: any) {
//     this.currentEntity = 'client';
//     this.modalService.dismissAll();
//     this.action = action;
//     this.openModal(Content);

//     if (this.action === 'Add') {
//       this.client = new ClientRegistration();
//       this.client.clientRegistrationUId = Guid.newGuid();
//       this.clientregistrationidgen();
//     }
//     if (rowdata) {
//       this.client = rowdata;
//       this.logoChoosefile = this.client.logo.split('/')[this.client.logo.split('/').length - 1];
//       this.ProductUID = this.client.productUId;
//       this.client.dateofBirth = this.client.dateofBirth ? this.client.dateofBirth?.toString().slice(0, 10) : null;
//       this.client.date = this.client.date ? this.client.date?.toString().slice(0, 10) : null;
//       this.client.registrationDate = this.client.registrationDate ? this.client.registrationDate?.toString().slice(0, 10) : null;
//       this.client.joiningDate = this.client.joiningDate ? this.client.joiningDate?.toString().slice(0, 10) : null;
//       this.signatureChoosefile = this.client.signature.split('/')[this.client.signature.split('/').length - 1];
//     }
//   }

//   clientregistrationidgen() {
//     this.clientService.getClientMaxId().subscribe(
//       (data: ClientRegistration): void => {
//         this.ClientRegistrationID = data;
//       },
//       (error: HttpErrorResponse): void => {
//         this.client.clientRegistrationId = 1000;
//         console.log(error);
//       }
//     );
//   }

//   updateClientFilter(event) {
//     const val = event.target.value.toLowerCase();
//     const filtered = this.clientTempAll.filter(d =>
//       d.companyName.toLowerCase().indexOf(val) !== -1 || !val
//     );
//     this.ClientData = filtered;
//     if (this.clientTable) { this.clientTable.offset = 0; }
//   }

//   GetProductUId(e) {
//     this.ProductUID = e.target.value;
//   }

//   updateAddrs(e) {
//     this.CommunicationAddr = this.client.communicationAddress;
//     this.PermanentAddr = this.client.permanentAddress;
//     if (e) {
//       this.PermanentAddr = this.CommunicationAddr;
//       this.client.permanentAddress = this.PermanentAddr;
//     } else {
//       this.client.permanentAddress = '';
//     }
//   }

//   onFileChange(files: FileList) {
//     this.logoChoosefile = Array.from(files).map(f => f.name).join(', ');
//     this.logoFileToUpload = files.item(0);
//   }

//   onFileChangeSignature(files: FileList) {
//     this.signatureChoosefile = Array.from(files).map(f => f.name).join(', ');
//     this.signatureFileToUpload = files.item(0);
//   }

//   private companyFolder(): string {
//     return JSON.parse(localStorage.getItem('currentUser')).clientRegistration.companyName;
//   }

//   upload() {
//     if (!this.logoFileToUpload) { return; }
//     const filedata = new FormData();
//     filedata.append('file', this.logoFileToUpload, this.logoFileToUpload.name);
//     this.clientService.commonUpload('ABGCommonFileUpload/' + this.companyFolder(), 'Logo', filedata).subscribe((): void => { });
//   }

//   uploadSignature() {
//     if (!this.signatureFileToUpload) { return; }
//     const filedata = new FormData();
//     filedata.append('file', this.signatureFileToUpload, this.signatureFileToUpload.name);
//     this.clientService.commonUpload('ABGCommonFileUpload/' + this.companyFolder(), 'Signature', filedata).subscribe((): void => { });
//   }

//   SaveClient(clientForm: NgForm) {
//     if (this.action == 'Delete') {
//       this.client.itemState = 3;
//       this.client.rowStatusUId = RowStatuses.Inactive;
//       this.client.productUId = this.ProductUID;
//       this.setAuditFields(this.client);
//       this.spinner.show();
//       this.clientService.mergeClient(this.client, this.action).subscribe(
//         (): void => {
//           this.spinner.hide();
//           this.modalService.dismissAll();
//           this.getmasterdata();
//           this.alertService.success('Client Details Deleted successfully');
//           clientForm?.reset();
//         },
//         (error: HttpErrorResponse): void => {
//           console.log(error);
//           this.alertService.error(error.message);
//           this.spinner.hide();
//         });
//     } else {
//       if (clientForm && clientForm.valid) {
//         this.client.itemState = this.action == 'Add' ? 1 : 2;
//         this.client.rowStatusUId = RowStatuses.Active;
//         this.client.signature = '/ABGCommonFileUpload/' + this.companyFolder() + '/Signature/' + this.signatureChoosefile;
//         this.client.logo = '/ABGCommonFileUpload/' + this.companyFolder() + '/Logo/' + this.logoChoosefile;
//         this.client.clientRegistrationId = this.ClientRegistrationID;
//         this.client.onlineSearch = this.onlineSearch;
//         this.client.referralFromFriendOrFamilyMember = this.referralFromFriendOrFamilyMember;
//         this.client.socialMedia = this.socialMedia;
//         this.client.advertisement = this.advertisement;
//         this.client.other = this.other;
//         this.client.informationProvidedTheBestOfMyKnowledge = false;
//         this.client.productUId = this.ProductUID;
//         this.client.joiningDate = this.currentDate;
//         this.client.confidentialBusinessPurposes = false;
//         this.setAuditFields(this.client);
//         this.spinner.show();
//         this.clientService.mergeClient(this.client, this.action).subscribe(
//           (): void => {
//             this.spinner.hide();
//             this.modalService.dismissAll();
//             this.uploadSignature();
//             this.upload();
//             this.getmasterdata();
//             this.alertService.success('Client Details saved successfully');
//             // If this client already has an account, we are done.
//             // Otherwise flow straight into account creation (in-page, no route hop).
//             this.accountService.getAccount().subscribe((getaccountdetaildata: Array<Account>): void => {
//               this.AccountData = getaccountdetaildata;
//               if (this.AccountData?.filter(acc => acc.clientRegistrationUId === this.client.clientRegistrationUId).length > 0) {
//                 clientForm.reset();
//               } else {
//                 this.TransfertoAccountRegistration(this.client.clientRegistrationUId);
//               }
//             });
//           },
//           (error: HttpErrorResponse): void => {
//             console.log(error);
//             this.alertService.error(error.message);
//             this.spinner.hide();
//           });
//       } else {
//         this.alertService.warning('Enter All the Fields');
//       }
//     }
//   }

//   /** True when the client has no account yet (shows the "Create account" row action). */
//   validateAccountRegistration(clientRegistrationUId): boolean {
//     return !(this.AccountData?.filter(acc => acc.clientRegistrationUId === clientRegistrationUId).length > 0);
//   }

//   /**
//    * Previously navigated to /abg/accountregistration?clientRegistrationUId=...
//    * Now switches to the Accounts tab and opens the account form prefilled
//    * from the selected client — same workflow, single page.
//    */
//   TransfertoAccountRegistration(clientRegistrationUId) {
//     this.setTab('account');
//     this.clientRegistrationUId = clientRegistrationUId?.toString();
//     this.clientService.getClient(this.clientRegistrationUId).subscribe((clientregistration: Array<ClientRegistration>) => {
//       this.currentEntity = 'account';
//       this.action = 'Add';
//       this.account = new Account();
//       this.account.abgTechnologysAccountUId = Guid.newGuid();
//       this.abgtechnologyaccountidgen();
//       this.account.name = clientregistration[0].fullName;
//       this.account.email = clientregistration[0].emailAddress;
//       this.account.mobileNumber = clientregistration[0].mobileNumber1;
//       this.modalService.dismissAll();
//       this.openModal(this.AccountContent);
//     });
//   }

//   // ════════════════════════════════ ACCOUNT ═══════════════════════════════════

//   ViewAccountPopup(Content, action, rowdata?: Account) {
//     this.currentEntity = 'account';
//     this.LoggedInList = [];
//     this.modalService.dismissAll();
//     this.action = action;
//     this.openModal(Content);

//     if (this.action === 'Add') {
//       this.account = new Account();
//       this.account.abgTechnologysAccountUId = Guid.newGuid();
//       this.abgtechnologyaccountidgen();
//     }
//     if (rowdata) {
//       this.account = rowdata;
//       this.AccessUID = this.account.accessRoleUId;
//       this.ClientRegistrationUID = this.account.clientRegistrationUId;
//       if (this.account.roleBasedLogedin == LEGACY_ROLE_UID.TRAINER) {
//         this.account.roleBasedLogedin = RoleBasedLoggedin.Trainer;
//       } else if (this.account.roleBasedLogedin == LEGACY_ROLE_UID.TRAINEE) {
//         this.account.roleBasedLogedin = RoleBasedLoggedin.Trainee;
//       } else if (this.account.roleBasedLogedin == LEGACY_ROLE_UID.MANAGER) {
//         this.account.roleBasedLogedin = RoleBasedLoggedin.Manager;
//       }
//       if (this.account.loggedInUId == null) {
//         this.DisplayLoggedIn = false;
//       } else {
//         this.DisplayLoggedIn = true;
//         this.loggedInUId = this.account.loggedInUId;
//       }
//     }
//   }

//   abgtechnologyaccountidgen() {
//     this.accountService.getAccountId().subscribe(
//       (data: Account): void => {
//         this.AccountRegistrationId = data;
//       },
//       (error: HttpErrorResponse): void => {
//         this.account.abgTechnologysAccountId = 1000;
//         console.log(error);
//       }
//     );
//   }

//   updateAccountFilter(event) {
//     const val = event.target.value.toLowerCase();
//     const filtered = this.accountTempAll.filter(d =>
//       d.name.toLowerCase().indexOf(val) !== -1 || !val
//     );
//     this.AccountData = filtered;
//     if (this.accountTable) { this.accountTable.offset = 0; }
//   }

//   /** Client changed → work out which "Logged In" UI the product requires. */
//   GetLogInDetails(e) {
//     this.LoggedInList = [];
//     this.GYMRadio = false;
//     this.DisplayLoggedIn = false;
//     this.account.loggedInUId = null;
//     this.ClientRegistrationUID = e.target.value;
//     this.productUId = this.Clientregistrationlist.find(s => s.clientRegistrationUId === this.ClientRegistrationUID).productUId;

//     if (this.productUId === PRODUCT_UID.ENGINEERING) {
//       this.DisplayLoggedIn = true;
//       this.Engineers = this.Engineerlist?.filter(s => s.clientRegistrationUId == e.target.value);
//       this.Engineers.forEach(s => {
//         this.LoggedInList.push({ 'value': s.engineerRegistrationUId, 'Label': s.name });
//       });
//     }
//     if (this.productUId === PRODUCT_UID.GYM) {
//       this.GYMRadio = true;
//       this.DisplayLoggedIn = true;
//     }
//     if (this.productUId === PRODUCT_UID.ATTENDANCE) {
//       this.DisplayLoggedIn = true;
//       this.Employees = this.EmployeeList?.filter(s => s.clientRegistrationUId == this.ClientRegistrationUID);
//       this.LoggedInList = [];
//       this.Employees.forEach(s => {
//         this.LoggedInList.push({ 'value': s.attendanceEmployeeRegistrationUId, 'Label': s.name });
//       });
//     }
//   }

//   /** GYM product: Trainee / Trainer / Manager radio changed. */
//   GetGYMLogInDetails(e) {
//     this.account.loggedInUId = null;
//     if (e.target.value === 'Trainee') {
//       this.gymService.getGym(false, false, false, false, '0', '10', this.clientRegistrationUId?.toString(), '', null, true)
//         .subscribe((getcustomerData: Array<CustomerRegistration>) => {
//           this.Customerlists = getcustomerData;
//         });
//       this.Customers = this.Customerlists?.filter(s => s.clientRegistrationUId == this.ClientRegistrationUID);
//       this.LoggedInList = [];
//       this.Customers.forEach(s => {
//         this.LoggedInList.push({ 'value': s.gymRegistrationUId, 'Label': s.name });
//       });
//       this.account.roleBasedLogedin = RoleBasedLoggedin.Trainee;
//     } else if (e.target.value === 'Trainer') {
//       this.traineeService.getTraineeRegistrationFilterUrl(this.ClientRegistrationUID.toString())
//         .subscribe((getTraineeData: Array<TraineeRegistration>) => {
//           this.Traineelist = getTraineeData;
//         });
//       this.Trainees = this.Traineelist?.filter(s => s.clientRegistrationUId == this.ClientRegistrationUID);
//       this.LoggedInList = [];
//       this.Trainees.forEach(s => {
//         this.LoggedInList.push({ 'value': s.gymTraineeRegistrationUId, 'Label': s.name });
//       });
//       this.account.roleBasedLogedin = RoleBasedLoggedin.Trainer;
//     } else if (e.target.value === 'Manager') {
//       this.gymmanagerService.getGYMManagerRegistrationFilterUrl(this.ClientRegistrationUID.toString())
//         .subscribe((getManagerData: Array<GYMManagerRegistration>) => {
//           this.Managerlist = getManagerData;
//         });
//       this.Managers = this.Managerlist?.filter(s => s.clientRegistrationUId == this.ClientRegistrationUID);
//       this.LoggedInList = [];
//       this.Managers?.forEach(s => {
//         this.LoggedInList.push({ 'value': s.gymManagerRegistrationUId, 'Label': s.name });
//       });
//       this.account.roleBasedLogedin = RoleBasedLoggedin.Manager;
//     }
//   }

//   /** Selection made in the "Logged In" dropdown → prefill contact details. */
//   getDetails(e) {
//     if (this.account.roleBasedLogedin === RoleBasedLoggedin.Trainer) {
//       this.traineeService.getTraineeRegistrationUID(e.value).subscribe((gettraineeinfodata): void => {
//         this.account.name = gettraineeinfodata.name;
//         this.account.email = gettraineeinfodata.eMailId;
//         this.account.mobileNumber = gettraineeinfodata.phoneNumber1;
//       });
//     } else if (this.account.roleBasedLogedin === RoleBasedLoggedin.Trainee) {
//       this.gymService.getGymRegistrationUID(e.value).subscribe((getcustomerinfodata): void => {
//         this.account.name = getcustomerinfodata.name;
//         this.account.email = getcustomerinfodata.eMailId;
//         this.account.mobileNumber = getcustomerinfodata.phoneNumber1;
//       });
//     } else if (this.account.roleBasedLogedin === RoleBasedLoggedin.Manager) {
//       this.gymmanagerService.getGYMManagerRegistrationUID(e.value).subscribe((getmanagerinfodata): void => {
//         this.account.name = getmanagerinfodata.name;
//         this.account.email = getmanagerinfodata.eMailId;
//         this.account.mobileNumber = getmanagerinfodata.phoneNumber1;
//       });
//     }
//   }

//   GetAccessroleUId(e) {
//     this.AccessUID = e.target.value;
//     if (e.target.value === AccessRoleUID.SuperAdmin || e.target.value === AccessRoleUID.Admin) {
//       // SuperAdmin / Admin do not map to a role-based login.
//     } else if (this.productUId === PRODUCT_UID.ENGINEERING) {
//       this.account.roleBasedLogedin = RoleBasedLoggedin.Engineer;
//     } else if (this.productUId === PRODUCT_UID.GYM) {
//       // GYM role is chosen via the Trainee / Trainer / Manager radios.
//     } else if (this.productUId === PRODUCT_UID.ATTENDANCE) {
//       this.account.roleBasedLogedin = RoleBasedLoggedin.Employee;
//     }
//   }

//   Saveaccount(accountForm: NgForm) {
//     if (this.action == 'Delete') {
//       this.account.itemState = 3;
//       this.account.rowStatusUId = RowStatuses.Inactive;
//       this.account.clientRegistrationUId = this.ClientRegistrationUID;
//       this.account.accessRoleUId = this.AccessUID;
//       this.setAuditFields(this.account);
//       this.spinner.show();
//       this.accountService.mergeAccount(this.account, this.action).subscribe(
//         (): void => {
//           this.spinner.hide();
//           this.modalService.dismissAll();
//           this.getmasterdata();
//           this.alertService.success('Account Deleted successfully');
//           accountForm?.reset();
//         },
//         (error: HttpErrorResponse): void => {
//           console.log(error);
//           this.alertService.error(error.message);
//           this.spinner.hide();
//         });
//     } else {
//       if (accountForm && accountForm.valid) {
//         this.account.itemState = this.action == 'Add' ? 1 : 2;
//         this.account.rowStatusUId = RowStatuses.Active;
//         this.account.clientRegistrationUId = this.ClientRegistrationUID;
//         this.account.accessRoleUId = this.AccessUID;
//         this.account.loggedInUId = this.loggedInUId;
//         this.account.abgTechnologysAccountId = this.AccountRegistrationId;
//         this.account.productUId = this.productUId;
//         this.setAuditFields(this.account);

//         this.spinner.show();
//         this.accountService.getAccount().subscribe((getaccountdetaildata: Array<Account>): void => {
//           this.AccountData = getaccountdetaildata;
//           this.spinner.hide();
//         });

//         if (this.AccountData?.filter(acc => acc.email === this.account.email).length > 0) {
//           this.alertService.warning('EmailID Already Exists');
//           this.account.email = '';
//         }
//         if (this.AccountData?.filter(acc => acc.mobileNumber === this.account.mobileNumber).length > 0) {
//           this.alertService.warning('Mobile Number Already Exists');
//           this.account.mobileNumber = '';
//         }
//         if (this.AccountData?.filter(acc => acc.loggedInUId === this.account.loggedInUId).length > 0) {
//           this.alertService.warning('Already Account Created');
//           this.account.loggedInUId = '';
//         } else {
//           this.spinner.show();
//           this.accountService.mergeAccount(this.account, this.action).subscribe(
//             (): void => {
//               this.spinner.hide();
//               this.modalService.dismissAll();
//               this.getmasterdata();
//               this.alertService.success('Account added successfully');
//               accountForm.reset();
//             },
//             (error: HttpErrorResponse): void => {
//               console.log(error);
//               this.alertService.error(error.message);
//               this.spinner.hide();
//             });
//         }
//       } else {
//         this.alertService.warning('Please Enter valid Account Details');
//       }
//     }
//   }
// }
















//import { Component, Inject, OnInit, ViewChild } from '@angular/core';
//import { Router } from '@angular/router';
//import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
//import { AuthService } from '../_services/auth.service';
//import { AlertService } from '../_services/alert.service';
//import { UserService } from '../_api/user/user.service';
//import { ToastrService } from 'ngx-toastr';
//import firebase from 'firebase/compat/app';
//import 'firebase/compat/auth';
//import 'firebase/compat/firestore';
//import { ForgotPassword } from '../model/forgotpassword.model';
//import { SharedComponent } from '../../shared/shared.component';
//import { AccountService } from '../_services/domainservice/account.service';
//import { Account } from '../model/account.model';
//import { RoleBasedLoggedin } from '../model/masterModel/RoleBasedLogedin.model';
//import { GymService } from '../_services/domainservice/gym.service';
//import { TraineeRegistration } from '../model/gymtraineeregistration.model';
//import { GYMManagerRegistrationService } from '../_services/domainservice/gymmanagerregistration.service';
//import { TraineeRegistrationService } from '../_services/domainservice/gymtraineeregistration.service';
//import { RowStatuses } from '../model/masterModel/RowStatuses.model';
//import { Guid } from '../_helpers/guid';
//import { ForgotPasswordService } from '../_services/domainservice/forgotpassword.service';
//import { HttpErrorResponse, HttpClient } from '@angular/common/http';
//import { NgxSpinnerService } from 'ngx-spinner';
//import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { error } from 'console';

//@Component({
//  templateUrl: 'register.component.html',
//  styleUrls: ['./register.component.css']
//})
//export class RegisterComponent extends SharedComponent implements OnInit {
//  forgetPasswordForm: FormGroup;
//  submitted = false;
//  otpSent: boolean = false;
//  errorMessage: string = '';
//  AccountList: Array<Account>;
//  //email: string = '';
//  //@ViewChild('forgotpwdForm', { static: false }) forgotpwdForm!: NgForm;

//  //forgotpwd: ForgotPassword = new ForgotPassword;
//  //emails: boolean = false;
//  //mobilenumbers: boolean = false;
//  //Accountlist: Array<Account>;
//  //passwordid: any;
//  //account: Account = new Account;
//  //otp: string = '';
//  //VerificationMethod: string = '';
//  //otpclick: boolean = true;
//  //generateOTP!= Number;
//  //private http = Inject(HttpClient);

//  constructor(
//    private formBuilder: FormBuilder,
//    private router: Router,
//    private alertService: AlertService,
//    private authService: AuthService,
//    private userService: UserService,
//    private accountService: AccountService,
//    private customerService: GymService,
//    private trainerService: TraineeRegistrationService,
//    private managerService: GYMManagerRegistrationService,
//    private forgetpasswordService: ForgotPasswordService,
//    private spinner: NgxSpinnerService,
//    private modalService: NgbModal,
//    private http: HttpClient
//      ) {
//    super();
//  }

//  ngOnInit() {
//    this.forgetPasswordForm = this.formBuilder.group({
//      email: ['', [Validators.required, Validators.email]]
//    });

//    //this.forgotpwd.forgotPasswordUId = Guid.newGuid();
//    //this.idgen();
//  }
//  get f() { return this.forgetPasswordForm.controls; }


//  onSubmit() {
//    if (this.forgetPasswordForm.valid) {
//      this.accountService.getAccountEmail(this.getBase64Encode(this.forgetPasswordForm.value.email)).subscribe((accountdata): void => {
//        if (this.forgetPasswordForm.value.email === accountdata.email) {
//          this.router.navigate(['/sendotp'], { queryParams: { Email: this.forgetPasswordForm.value.email } })
//        }
//      });
//      //this.authService.sendOtp(this.forgetPasswordForm.value.email).subscribe(response => {
//      //  this.errorMessage = response.message;
//      //  this.router.navigate(['/sendotp', this.forgetPasswordForm.value.email]);

//      //}, error => {
//      //  this.errorMessage = 'Error sending OTP!';
//      //});
//    }
//      //this.http.post('http://localhost:4200/register', this.forgetPasswordForm.value.email)
//      //  .subscribe(
//      //    (response) => {
//      //      this.otpSent = true; // Show OTP input
//      //      this.router.navigate(['/sendotp', this.forgetPasswordForm.value.email]);
//      //    },
//      //    (error) => {
//      //      this.errorMessage = 'Error sending OTP. Please try again.';
//      //      console.error(error);
//      //    }
//      //  );

//      //this.authService.sendOtp(this.email).subscribe(
//      //  response => {
//      //    alert('OTP sent to your email');
//      //    this.router.navigate(['/verifyotp', this.email]);
//      //  },
//      //  error => {
//      //    alert('Error sending OTP');
//      //  }
//      //);
//  }


//    //this.submitted = true;
//    //this.accountService.getAccountEmail(this.getBase64Encode(this.forgetPasswordForm.value.email)).subscribe((accountdata): void => {
//    //  if (this.forgetPasswordForm.value.email === accountdata.email) {
//    //    this.accountService.forgotsendmailpassword(accountdata).subscribe((data): void => {
//    //      alert('reset link is sent to ur registered emailid')
//    //      this.router.navigate(['/login'])

//    //    });

//    //  }
//    //})
//    //this.accountService.forgotsendmailpassword().subscribe((data): void => {
//    //  /* for (var i = 0; i < data.length; i++) {*/
//    //  if (this.forgetPasswordForm.value.email === data.email) {
//    //    alert('Reset Link is sent to ur registered EmailID')
//    //    this.router.navigate(['/login'])
//    //  }
//    //  else {
//    //    alert('something went wrong')
//    //  }
//    //  /*}*/
//    //})
//    //this.authService.forgetPassword(this.email);
//    //this.email = '';

//    //  this.submitted = true;
//    //  //this.alertService.clear();

//    //  if (this.forgetPasswordForm.invalid) {
//    //    return;
//    //  }

//    //  this.spinner.show();
//    //  this.authService.forgetPassword(this.forgetPasswordForm.value.email)
//    //    .subscribe({
//    //      next: () => {
//    //        this.alertService.success('Password reset link sent to your email');
//    //        this.router.navigate(['/login']);
//    //      },
//    //      error: (error) => {
//    //        this.alertService.error(error);
//    //        this.spinner.hide();
//    //      },
//    //      complete: () => this.spinner.hide()
//    //    });
//    //}

//  }
//  //idgen() {
//  //  this.forgetpasswordService.getForgotPasswordMaxId().subscribe((data: ForgotPassword): void => {
//  //    this.passwordid = data;
//  //  }, (error: HttpErrorResponse): void => {
//  //    this.forgotpwd.forgotPasswordId = 1000;
//  //    console.log(error);
//  //  });
//  //}
//  //selectedMethodisenabled(e) {
//  //  if (e.target.value === 'Email') {
//  //    this.emails = true;
//  //    this.mobilenumbers = false;
//  //  }
//  //  else if (e.target.value === 'MobileNumber') {
//  //    this.mobilenumbers = true;
//  //    this.emails = false;
//  //  }
//  //}
//  //GenerateOTP() {
//  //  this.otpgenertor();
//  //  this.otpclick = false;
//  //  //const otpData = { otp: this.otp };
//  //  //this.http.post('http://localhost:4200/api/verify-otp', otpData).
//  //  //  subscribe({
//  //  //    next: (Response: any) => {
//  //  //      if (Response.success) {
//  //  //        this.VerificationMethod = 'OTP Verified Successfully';
//  //  //      }
//  //  //      else {
//  //  //        this.VerificationMethod = 'OTP Verification Failed';

//  //  //      }
//  //  //    },
//  //  //    error: (error) => {
//  //  //      this.VerificationMethod = 'The Error Occur while verifying OTP';
//  //  //      console.error('There was on error!', error);
//  //  //    },
//  //  //  });
//  //}
//  //otpgenertor()
//  //{
//  //  let no = Math.random();
//  //  this.forgotpwd.verificationCode = Math.round(no * 900000 + 100000).toString();
//  //}

//  //getMobileNumber(e)
//  //{
//  //  this.accountService.getAccount().subscribe((getaccountdata): void => {
//  //    this.Accountlist = getaccountdata;
//  //    for (var i = 0; i < getaccountdata.length; i++) {
//  //      if (getaccountdata[i].email === e.target.value) {
//  //        this.forgotpwd.mobileNumber = getaccountdata[i].mobileNumber;
//  //        if (getaccountdata[i].roleBasedLogedin === '00200000-0000-0000-0000-000000000000') {
//  //          this.customerService.getGymRegistrationUID(getaccountdata[i].loggedInUId.toString()).subscribe((getcustomerdata): void => {
//  //            this.forgotpwd.dateOfBirth = getcustomerdata.dateofBirth.toString().slice(0, 10);
//  //          })
//  //        }
//  //        if (getaccountdata[i].roleBasedLogedin === '00100000-0000-0000-0000-000000000000')
//  //        {
//  //          this.trainerService.getTraineeRegistrationUID(getaccountdata[i].loggedInUId.toString()).subscribe((gettrainerdata): void => {
//  //            this.forgotpwd.dateOfBirth = gettrainerdata.dateofBirth.toString().slice(0,10);
//  //          })
//  //        }
//  //        if (getaccountdata[i].roleBasedLogedin === '00500000-0000-0000-0000-000000000000') {
//  //          this.managerService.getGYMManagerRegistrationUID(getaccountdata[i].loggedInUId.toString()).subscribe((getmanagerdata): void => {
//  //            this.forgotpwd.dateOfBirth = getmanagerdata.dateofBirth.toString().slice(0, 10);
//  //          })
//  //        }
//  //      }
//  //    }
//  //  })
//  //}
//  //CheckConfirmPassword(e)
//  //{
//  //  if (this.forgotpwd.newPassword === e.target.value) {

//  //  }
//  //  else
//  //  {
//  //    this.alertService.warning('Pls check the Passwords')
//  //    e.target.value = "";
//  //  }
//  //}
//  //getEmailID(e)
//  //{
//  //  this.accountService.getAccount().subscribe((getaccountdata): void => {
//  //    this.Accountlist = getaccountdata;
//  //    for (var i = 0; i < getaccountdata.length; i++) {
//  //      if (getaccountdata[i].mobileNumber === e.target.value) {
//  //        this.forgotpwd.email = getaccountdata[i].email;
//  //        if (getaccountdata[i].roleBasedLogedin === '00200000-0000-0000-0000-000000000000') {
//  //          this.customerService.getGymRegistrationUID(getaccountdata[i].loggedInUId.toString()).subscribe((getcustomerdata): void => {
//  //            this.forgotpwd.dateOfBirth = getcustomerdata.dateofBirth.toString().slice(0, 10);
//  //          })
//  //        }
//  //        if (getaccountdata[i].roleBasedLogedin === '00100000-0000-0000-0000-000000000000') {
//  //          this.trainerService.getTraineeRegistrationUID(getaccountdata[i].loggedInUId.toString()).subscribe((gettrainerdata): void => {
//  //            this.forgotpwd.dateOfBirth = gettrainerdata.dateofBirth.toString().slice(0, 10);
//  //          })
//  //        }
//  //        if (getaccountdata[i].roleBasedLogedin === '00500000-0000-0000-0000-000000000000') {
//  //          this.managerService.getGYMManagerRegistrationUID(getaccountdata[i].loggedInUId.toString()).subscribe((getmanagerdata): void => {
//  //            this.forgotpwd.dateOfBirth = getmanagerdata.dateofBirth.toString().slice(0, 10);
//  //          })
//  //        }
//  //      }
//  //    }
//  //  })
//  //}
//  //SavenewPassword(forgotpwdForm) {
//  //  if (forgotpwdForm && forgotpwdForm.valid) {

//  //    /*this.forgotpwd.itemState = 1;*/
//  //    this.forgotpwd.rowStatusUId = RowStatuses.Active;
//  //    this.forgotpwd.forgotPasswordId = this.passwordid;
//  //    this.setAuditFields(this.forgotpwd);
//  //    this.spinner.show();
//  //    this.forgetpasswordService.mergeForgotPassword(this.forgotpwd, 'Add').subscribe((): void => {
//  //      this.spinner.hide();
//  //      this.UpdateAccountPassword();
//  //      this.alertService.success('New Password Saved successfully');
//  //      this.router.navigate(['/login']);
//  //      //forgotpwdForm.reset();
//  //    },
//  //      (error: HttpErrorResponse): void => {
//  //        console.log(error);
//  //        this.alertService.error(error.message);
//  //        this.spinner.hide();
//  //      });
//  //  }
//  //  else {
//  //    this.alertService.warning('Please Enter Valid Fields');
//  //  }
//  //}
//  //UpdateAccountPassword()
//  //{
//  //  this.accountService.getAccount().subscribe((getaccountdata): void => {
//  //    this.Accountlist = getaccountdata;
//  //    for (var i = 0; i < getaccountdata.length; i++) {
//  //      if (getaccountdata[i].email === this.forgotpwd.email) {
//  //        getaccountdata[i].itemState = 2;
//  //        getaccountdata[i].password = this.forgotpwd.newPassword;
//  //        this.accountService.mergeAccount(getaccountdata[i], 'Edit').subscribe((): void => {
//  //        },
//  //          (error: HttpErrorResponse): void => {
//  //            console.log(error);
//  //            this.alertService.error(error.message);
//  //            this.spinner.hide();
//  //          });
//  //      }
//  //    }
//  //  },
//  //    (error: HttpErrorResponse): void => {
//  //      console.log(error);
//  //      this.alertService.error(error.message);
//  //      this.spinner.hide();
//  //    });
//  //}





import { Component, OnDestroy, OnInit, QueryList, ViewChildren, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from '../_services/domainservice/account.service';

/**
 * UNIFIED REGISTRATION WIZARD
 * Merges the previous NewRegistration (account + product + OTP) with the Company Details
 * page into ONE self-service flow. No functionality is dropped — only de-duplicated.
 *
 *   Step 1  Account   -> full name, email, mobile, password, terms   (creates the admin Users row)
 *   Step 2  Company   -> full organisation + contact details          (held client-side)
 *   Step 3  Product   -> pick ONE product (drives the tenant config)
 *   Step 4  Verify    -> email OTP; on success the backend provisions the tenant
 *                        (ClientRegistration + CompanyDetails) via usp_SelfRegister_ProvisionTenant
 *                        and redirects to /login.
 *
 * Backend contract (unchanged endpoints, extended verify payload):
 *   accountService.register(payload)        -> POST api/auth/register/start   (send OTP)
 *   accountService.registerVerify(payload)  -> POST api/auth/register/verify  (confirm OTP + provision)
 *
 * Tenant ID and Client Registration ID are generated SERVER-SIDE (never trust the client),
 * so the wizard does not invent them.
 */
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, OnDestroy {
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef<HTMLInputElement>>;

  step = 1;                 // 1..4
  loading = false;
  errorMessage = '';
  successMessage = '';
  showPassword = false;

  accountForm!: FormGroup;  // step 1
  companyForm!: FormGroup;  // step 2
  accSubmitted = false;
  coSubmitted = false;

  otpBoxes = [0, 1, 2, 3, 4, 5];
  otpDigits: string[] = ['', '', '', '', '', ''];
  resendCountdown = 0;
  private resendTimer: any;

  passwordStrength = 0;
  strengthClass = '';

  // The seven products from the current business process.
  products = [
    { id: 'GYM', name: 'GYM Management', icon: 'la-heartbeat', cssClass: 'auth-pi--gym' },
    { id: 'CRM', name: 'CRM & Inventory', icon: 'la-cubes', cssClass: 'auth-pi--crm' },
    { id: 'TICKET', name: 'Ticket Management', icon: 'la-ticket', cssClass: 'auth-pi--ticket' },
    { id: 'BILLING', name: 'Billing Application', icon: 'la-file-text-o', cssClass: 'auth-pi--billing' },
    { id: 'RETAIL', name: 'KG Retail Management', icon: 'la-shopping-cart', cssClass: 'auth-pi--retail' },
    { id: 'ERP', name: 'KG Inventory & Billing ERP', icon: 'la-database', cssClass: 'auth-pi--erp' },
    { id: 'HRM', name: 'HRM Application', icon: 'la-users', cssClass: 'auth-pi--hrm' }
  ];
  selectedProducts: string[] = [];

  companyTypes = ['Proprietorship', 'Partnership', 'Private Limited', 'Public Limited', 'LLP', 'HUF', 'Trust', 'Society', 'Other'];
  industries = ['Retail', 'Manufacturing', 'IT / Software', 'Healthcare', 'Education', 'Textile / Garment', 'Hospitality', 'Logistics', 'Construction', 'Other'];
  licenseTypes = ['Trial', 'Standard', 'Professional', 'Enterprise'];
  subscriptionPlans = ['Starter', 'Growth', 'Business', 'Premium'];

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly accountService: AccountService
  ) { }

  ngOnInit(): void {
    this.accountForm = this.fb.group({
      fullName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.minLength(10), Validators.pattern(/^[0-9]{10}$/)]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      acceptTerms: [false, Validators.requiredTrue],
      referralCode: ['']

    });

    // GST/PAN/CIN/PIN validated with the same shapes the CompanyDetails CHECK constraints enforce.
    this.companyForm = this.fb.group({
      companyName: ['', Validators.required],
      companyLegalName: [''],
      companyRegistrationNumber: [''],
      companyType: [''],
      industry: [''],
      gstNumber: ['', [Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/)]],
      panNumber: ['', [Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)]],
      cinNumber: [''],
      msmeUdyamNumber: [''],
      iecNumber: [''],
      companyWebsite: [''],
      companyEmail: ['', [Validators.required, Validators.email]],
      companyPhone: ['', [Validators.required, Validators.minLength(10)]],
      alternatePhone: [''],
      companyAddress: [''],
      city: [''],
      state: [''],
      country: ['India'],
      pinCode: ['', [Validators.pattern(/^[1-9][0-9]{5}$/)]],
      contactFullName: ['', Validators.required],
      contactDesignation: [''],
      contactMobile: ['', [Validators.required, Validators.minLength(10)]],
      contactEmail: ['', [Validators.email]],
      alternateContact: [''],
      licenseType: ['Trial'],
      subscriptionPlan: ['Starter']
    });
  }

  ngOnDestroy(): void {
    if (this.resendTimer) { clearInterval(this.resendTimer); }
  }

  get rf() { return this.accountForm.controls; }
  get cf() { return this.companyForm.controls; }

  // ---------- Step 1: Account ----------
  submitAccount(): void {
    this.accSubmitted = true;
    this.errorMessage = '';
    this.successMessage = '';

    if (this.accountForm.invalid) {
      this.errorMessage = 'Please complete all required account fields.';
      return;
    }
    // Pre-fill the company contact block from the account to save typing.
    this.companyForm.patchValue({
      companyName: this.companyForm.value.companyName|| this.accountForm.value.companyName,
      companyEmail: this.companyForm.value.companyEmail || this.accountForm.value.email,
      companyPhone: this.companyForm.value.companyPhone || this.accountForm.value.mobile,
      contactFullName: this.companyForm.value.contactFullName || this.accountForm.value.fullName,
      contactMobile: this.companyForm.value.contactMobile || this.accountForm.value.mobile,
      contactEmail: this.companyForm.value.contactEmail || this.accountForm.value.email
    });
    this.step = 2;
  }

  // ---------- Step 2: Company ----------
  submitCompany(): void {
    this.coSubmitted = true;
    this.errorMessage = '';
    if (this.companyForm.invalid) {
      this.errorMessage = 'Please complete the required company fields (and fix any invalid GST/PAN/PIN).';
      return;
    }
    this.step = 3;
  }

  // ---------- Step 3: Product + send OTP ----------
  finishRegistration(): void {
    if (this.selectedProducts.length === 0) {
      this.errorMessage = 'Select a product to continue.';
      return;
    }
    this.loading = true;
    this.errorMessage = '';
    this.successMessage = '';

    // Only the account is created now (unverified admin). Company is held until verify,
    // so a user who abandons the OTP step never leaves an orphan tenant behind.
    const payload = {
      fullName: this.accountForm.value.fullName,
      email: this.accountForm.value.email,
      mobile: this.accountForm.value.mobile,
      password: this.accountForm.value.password,
      companyName: this.accountForm.value.companyName,
      productCode: this.selectedProducts[0],
      acceptTerms: this.accountForm.value.acceptTerms === true,
      deviceFingerprint: this.buildDeviceFingerprint(),
      // Task #54: optional referral code — blank/whitespace is a no-op server-side.
      referralCode: (this.accountForm.value.referralCode || '').trim() || null

    };

    this.accountService.register(payload).subscribe({
      next: () => {
        this.loading = false;
        this.step = 4;
        this.otpDigits = ['', '', '', '', '', ''];
        this.successMessage = 'Verification code sent to your email.';
        this.startResendCountdown();
        setTimeout(() => this.focusOtp(0), 50);
      },
      error: (err: any) => {
        this.loading = false;
        this.errorMessage = this.getErrorMessage(err, 'Could not start registration. Please try again.');
      }
    });
  }
  private buildDeviceFingerprint(): string | null {
    try {
      const cached = localStorage.getItem('deviceFingerprint');
      if (cached) { return cached; }

      const raw = [
        navigator.userAgent,
        navigator.language,
        `${screen.width}x${screen.height}x${screen.colorDepth}`,
        Intl.DateTimeFormat().resolvedOptions().timeZone || '',
        String(navigator.hardwareConcurrency || '')
      ].join('|');

      let hash = 0;
      for (let i = 0; i < raw.length; i++) {
        hash = ((hash << 5) - hash + raw.charCodeAt(i)) | 0;
      }
      const fingerprint = Math.abs(hash).toString(36) + Date.now().toString(36).slice(-4);
      localStorage.setItem('deviceFingerprint', fingerprint);
      return fingerprint;
    } catch {
      return null; // localStorage/navigator unavailable (e.g. privacy mode) — IP check still applies
    }
  }

  // ---------- Step 4: Verify OTP + provision tenant ----------
  verifyOtp(): void {
    if (!this.isOtpComplete()) { return; }
    this.loading = true;
    this.errorMessage = '';
    this.successMessage = '';

    // Company block travels WITH the verify request; the backend provisions the tenant
    // (ClientRegistration + CompanyDetails) in the same success path via the proc.
    const payload = {
      email: this.accountForm.value.email,
      emailCode: this.otpDigits.join(''),
      productCode: this.selectedProducts[0],
      company: this.buildCompanyPayload()
    };

    this.accountService.registerVerify(payload).subscribe({
      next: () => {
        this.loading = false;
        this.successMessage = 'Account created and your organization is ready. Redirecting to sign in...';
        setTimeout(() => this.router.navigate(['/login']), 1500);
      },
      error: (err: any) => {
        this.loading = false;
        this.errorMessage = this.getErrorMessage(err, 'Invalid or expired code.');
      }
    });
  }

  private buildCompanyPayload() {
    const v = this.companyForm.value;
    return {
      companyName: v.companyName, companyLegalName: v.companyLegalName,
      companyRegistrationNumber: v.companyRegistrationNumber, companyType: v.companyType, industry: v.industry,
      gstNumber: v.gstNumber || null, panNumber: v.panNumber || null, cinNumber: v.cinNumber || null,
      msmeUdyamNumber: v.msmeUdyamNumber || null, iecNumber: v.iecNumber || null,
      companyWebsite: v.companyWebsite, companyEmail: v.companyEmail, companyPhone: v.companyPhone,
      alternatePhone: v.alternatePhone, companyAddress: v.companyAddress, city: v.city, state: v.state,
      country: v.country || 'India', pinCode: v.pinCode || null,
      contactFullName: v.contactFullName, contactDesignation: v.contactDesignation,
      contactMobile: v.contactMobile, contactEmail: v.contactEmail, alternateContact: v.alternateContact,
      licenseType: v.licenseType, subscriptionPlan: v.subscriptionPlan, renewalDate: null
    };
  }

  // ---------- password strength ----------
  onPasswordChange(): void {
    const val: string = this.accountForm.value.password || '';
    let score = 0;
    if (val.length >= 8) { score++; }
    if (/[A-Z]/.test(val) && /[a-z]/.test(val)) { score++; }
    if (/[0-9]/.test(val) && /[^A-Za-z0-9]/.test(val)) { score++; }
    this.passwordStrength = score;
    this.strengthClass = score <= 1 ? 'weak' : score === 2 ? 'medium' : 'strong';
  }

  // ---------- OTP input handling ----------
  onOtpInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;
    const val = input.value.replace(/[^0-9]/g, '');
    this.otpDigits[index] = val.slice(-1);
    input.value = this.otpDigits[index];
    if (this.otpDigits[index] && index < 5) { this.focusOtp(index + 1); }
  }
  onOtpKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace' && !this.otpDigits[index] && index > 0) { this.focusOtp(index - 1); }
  }
  onOtpPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const text = (event.clipboardData?.getData('text') || '').replace(/[^0-9]/g, '').slice(0, 6);
    for (let i = 0; i < 6; i++) { this.otpDigits[i] = text[i] || ''; }
    this.focusOtp(Math.min(text.length, 5));
  }
  private focusOtp(i: number): void {
    const arr = this.otpInputs?.toArray();
    if (arr && arr[i]) { arr[i].nativeElement.focus(); }
  }
  isOtpComplete(): boolean {
    return this.otpDigits.every(d => d && d.length === 1);
  }

  resendOtp(): void {
    if (this.resendCountdown > 0) { return; }
    // Re-issue the code by re-calling start (backend refreshes the OTP for the pending user).
    this.loading = true;
    const payload = {
      fullName: this.accountForm.value.fullName, email: this.accountForm.value.email,
      mobile: this.accountForm.value.mobile, password: this.accountForm.value.password,
      productCode: this.selectedProducts[0], acceptTerms: true,
      deviceFingerprint: this.buildDeviceFingerprint(),
      referralCode: (this.accountForm.value.referralCode || '').trim() || null

    };
    this.accountService.register(payload).subscribe({
      next: () => { this.loading = false; this.successMessage = 'A new code has been sent.'; this.startResendCountdown(); },
      error: (err: any) => { this.loading = false; this.errorMessage = this.getErrorMessage(err, 'Could not resend the code.'); }
    });
  }

  private startResendCountdown(): void {
    this.resendCountdown = 30;
    if (this.resendTimer) { clearInterval(this.resendTimer); }
    this.resendTimer = setInterval(() => {
      this.resendCountdown--;
      if (this.resendCountdown <= 0) { clearInterval(this.resendTimer); }
    }, 1000);
  }

  // ---------- product selection (single-select) ----------
  isProductSelected(id: string): boolean { return this.selectedProducts.indexOf(id) !== -1; }
  toggleProduct(id: string): void { this.selectedProducts = this.isProductSelected(id) ? [] : [id]; }

  goToStep(s: number): void { if (s < this.step) { this.step = s; } }

  private getErrorMessage(err: any, fallback: string): string {
    if (Array.isArray(err?.error?.errors)) { return err.error.errors.join(', '); }
    if (typeof err?.error === 'string') { return err.error; }
    if (typeof err?.error?.message === 'string') { return err.error.message; }
    return fallback;
  }
}


